// extracted by mini-css-extract-plugin
module.exports = {"button":"GraphTypeButton_button__3ZUZl"};